// TODO: Need to list all possible combinations anyway for i18nAlly to list them.
export const getSuccessTranslation = (label: string): string => {
  return `success_${label}`;
};
